<script setup>
import { onMounted, ref } from "vue";
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);

const svgRef = ref(null);

onMounted(() => {
  const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

  // Animación inicial de aparición
  tl.from(svgRef.value, {
    opacity: 0,
    scale: 0.3,
    transformOrigin: "center center",
    duration: 1,
  });

  // Animar los paths como dibujo
  tl.from(
    svgRef.value.querySelectorAll("path"),
    {
      drawSVG: "0%",
      stagger: 0.02,
      duration: 2,
    },
    "-=0.5"
  );

  // Aparición del color con rebote
  tl.from(
    svgRef.value.querySelectorAll("path"),
    {
      fillOpacity: 0,
      duration: 1,
      stagger: 0.03,
    },
    "-=1"
  );
});
</script>

<template>
  <section class="divider-flower">
    <svg
      ref="svgRef"
      width="355"
      height="345"
      viewBox="0 0 355 345"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M345.082 75.8937C312.138 82.2392 283.973 116.683 256.305 150.526C238.376 172.452 220.654 194.129 201.795 208.003C171.298 230.447 138.372 240.951 100.943 236.22C77.7899 233.289 60.1291 224.053 48.4497 211.689C23.4927 185.276 26.659 140.833 60.1689 114.971C87.881 93.5792 127.265 94.181 148.48 116.776C157.277 126.147 161.99 138.864 159.41 153.861C156.351 171.656 135.639 186.37 120.67 189.235C138.192 182.204 153.493 170.803 156.421 153.748C158.874 139.505 154.4 127.438 146.057 118.554C125.853 97.0314 88.4178 96.4833 62.033 116.849C29.808 141.716 26.9058 184.544 50.8729 209.911C62.1539 221.857 79.2508 230.789 101.686 233.626C138.235 238.251 170.214 227.99 199.99 206.083C218.525 192.442 236.115 170.922 253.91 149.167C256.841 145.578 310.419 75.8971 345.082 75.8937Z"
        fill="#9E0505"
      />
      <path
        d="M277.576 105.141C261.837 118.428 244.56 131.154 222.647 133.56C205.227 135.473 187.616 128.692 179.742 115.835C173.806 106.164 173.253 89.534 187.531 82.5933C196.292 78.338 206.553 80.5132 210.46 87.8609C212.056 90.8625 212.363 94.5432 210.637 98.4552C208.583 103.105 203.552 105.417 198.336 106.421C204.426 107.51 211.645 103.222 213.438 99.156C215.492 94.5066 215.128 90.1271 213.231 86.5662C208.651 77.9591 196.552 75.3489 186.278 80.34C170.43 88.0458 170.252 106.186 177.036 117.251C185.436 130.955 204.128 138.199 222.711 136.158C245.458 133.661 263.028 120.488 279.386 106.676C293.422 94.8278 308.237 82.3198 335.386 74.3233C309.538 78.0482 283.788 99.8946 277.576 105.141Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M332.234 122.877C339.698 99.0123 372.743 99.3242 377.633 121.414C379.561 130.137 375.748 139.52 368.502 146.568C353.931 160.744 331.197 165.144 314.07 156.2C292.456 144.902 288.566 119.461 303.447 99.6058C311.04 89.4746 323.085 82.4693 335.872 78.416C318.899 85.0212 308.98 95.7262 305.513 100.279C291.1 119.225 294.674 143.657 315.402 154.488C331.359 163.497 356.048 157.888 366.81 143.954C385.886 119.27 355.067 93.2273 332.234 122.877Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.6852 146.511C38.2253 145.08 38.8327 143.654 39.4945 142.254C51.899 116.063 86.8022 97.9483 116.88 105.542C141.75 111.825 153.46 134.633 142.86 156.854C138.061 166.905 129.34 174.846 118.062 179.693C110.961 182.738 102.986 183.032 95.8657 181.572C92.7783 180.938 89.5447 179.896 86.6071 178.478C95.9907 182.436 106.707 183.541 117.653 178.841C128.65 174.118 137.165 166.365 141.843 156.567C152.198 134.859 140.759 112.598 116.474 106.464C86.9398 99.0102 52.6796 116.849 40.5111 142.541C39.7872 144.071 39.1411 145.619 38.5581 147.18L37.6852 146.511Z"
        fill="#9E0505"
      />
      <path
        d="M179.246 131.219C175.403 129.976 171.102 133.738 172.082 137.758C173.234 142.505 179.369 148.899 194.289 152.154C213.165 156.276 236.516 151.8 253.965 140.743C260.377 136.39 266.353 131.242 271.602 125.455C259.402 137.47 245.508 145.907 228.819 149.619C212.99 153.138 193.461 151.943 181.364 145.151C179.086 143.869 174.855 140.435 175.678 138.429C176.127 137.34 179.994 139.117 181.439 135.949C182.442 133.769 181.358 131.915 179.246 131.219Z"
        fill="#9E0505"
      />
      <path
        d="M257.501 116.376C246.082 121.21 234.496 121.731 229.149 116.043C225.435 112.09 225.624 108.724 226.853 106.958C227.561 105.937 228.351 105.191 229.166 104.662C229.015 105.38 229.079 106.137 229.386 106.837C229.6 107.309 230.001 107.857 230.452 108.236C231.934 109.467 234.229 109.637 235.942 108.53C237.838 107.302 238.311 104.966 237.042 103.244C236.429 102.129 234.996 101.271 232.196 101.376C224.563 101.651 217.53 112.197 227.308 119.061C235.723 124.963 247.38 122.117 257.501 116.376Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.8221 160.297C65.5912 174.717 80.139 188.647 100.926 182.954C111.186 180.143 119.401 172.894 123.463 164.295C131.627 147.018 125.397 128.578 107.582 120.592C85.0887 110.508 55.9799 119.957 41.8794 140.198C34.689 150.521 32.9866 162.535 34.8036 173.662C33.7112 158.303 40.3953 146.031 43.5998 141.356C56.9465 121.893 84.823 112.699 106.389 122.369C123.711 129.485 129.588 149.91 119.852 164.341C104.27 187.439 67.9137 181.843 76.3355 157.945C77.3065 159.414 79.3213 160.191 81.4703 159.757C84.2721 159.197 86.243 156.816 85.8911 154.438C85.3034 150.537 80.5146 149.543 76.8868 152.422C74.336 154.45 72.5057 158.703 71.8221 160.297Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M294.926 151.377C299.868 156.463 306.27 156.546 308.42 156.414C307.804 161.82 294.843 160.714 291.808 160.84C306.055 165.181 301.425 173.242 311.661 175.902C308.962 177.398 305.759 178.292 302.34 178.565C299.119 178.824 295.718 178.532 292.399 177.71C285.024 175.891 276.81 168.444 277.007 155.289C277.019 154.743 277.038 154.183 277.082 153.615C277.781 143.096 280.855 132.837 291.511 116.115C285.335 133.225 288.2 144.474 294.926 151.377Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M130.395 227.46C127.885 208.866 154.537 208.824 181.14 203.866C204.395 199.537 217.671 188.146 219.493 181.506C216.938 184.544 211.358 189.058 197.622 190.128C190.767 190.665 184.717 186.691 186.967 182.022C173.978 178.826 172.824 191.258 179.816 196.49C173.745 197.982 165.592 189.879 165.558 183.846C157.419 184.939 156.702 191.415 159.828 193.55C153.913 192.716 147.221 191.067 142.454 196.406C145.043 197.099 144.804 201.495 147.211 201.289C138.967 204.422 123.117 214.584 130.395 227.46Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M327.621 176.653C334.54 183.663 346.759 181.976 349.446 172.736C350.303 169.809 347.867 166.983 344.63 166.091C342.273 165.448 340.195 166.68 341.13 168.259C335.631 168.237 337.643 161.054 345.047 161.237C351 161.39 354.337 167.532 352.428 172.928C350.677 177.863 344.63 181.39 338.61 181.357C340.228 182.401 342.052 182.857 344.083 183.283C338.992 185.89 332.341 187.209 324.64 177.583C324.163 179.29 324.612 181.203 325.802 183.121C317.53 181.025 319.371 178.988 318.888 173.825C318.541 170.119 316.515 167.625 311.594 165.825C317.558 165.969 324.78 173.768 327.621 176.653Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M333.001 71.8533C309.385 67.0677 289.686 84.5968 264.12 91.9498C250.258 95.938 240.866 93.8571 235.983 88.5105C236.949 91.5045 240.269 94.0523 245.353 96.1495C247.577 97.0665 250.636 97.6556 253.749 97.8875C260.28 102.569 264.433 101.256 270.111 93.0549C270.372 96.7393 271.54 98.6097 273.347 99.1917C279.052 101.026 289.101 90.4373 292.122 87.4444C298.598 81.0429 315.433 70.6911 333.001 71.8533Z"
        fill="#9E0505"
      />
      <path
        d="M334.41 100.237C335.183 99.2169 336.743 98.8824 337.907 99.28C339.112 99.7026 339.808 100.631 339.869 101.8C339.918 102.71 339.629 103.709 339.12 104.615C338.17 106.312 336.361 107.687 334.505 108.617C330.743 110.504 326.32 110.349 322.937 108.611C317.595 105.864 315.808 100.278 317.869 94.8482C320.178 88.713 327.137 83.852 334.456 81.2132C327.978 82.4594 319.804 87.1693 316.333 94.5339C314.041 100.576 316.079 106.792 322.004 109.842C325.867 111.829 330.919 111.964 335.197 109.815C337.386 108.721 339.451 107.109 340.562 105.119C341.196 103.997 341.551 102.741 341.489 101.589C341.4 99.9137 340.372 98.5728 338.644 97.9706C336.967 97.3846 334.736 98.4096 334.41 100.237Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M209.892 147.564C211.074 146.553 211.772 145.104 211.721 143.728C211.648 141.582 210.27 139.929 208.077 139.127C206.381 138.504 204.355 138.372 202.437 138.593C198.806 139.018 195.267 140.865 192.498 143.069C186.923 147.499 184.669 154.06 185.87 159.98C187.762 169.291 196.782 175.082 207.691 175.194C217.554 175.291 227.325 170.661 235.099 164.586C227.868 171.421 217.556 176.26 207.496 176.501C195.803 176.772 186.38 170.11 184.395 160.331C183.105 153.963 185.56 146.914 191.556 142.149C194.586 139.745 198.422 137.763 202.389 137.304C204.559 137.055 206.862 137.212 208.789 137.92C211.453 138.901 213.133 140.938 213.221 143.55C213.287 145.375 211.797 147.002 209.892 147.564Z"
        fill="#9E0505"
      />
      <mask
        id="mask0_39_944"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="24"
        width="317"
        height="250"
      >
        <path
          d="M0 110.494L53.3055 273.587L316.725 187.491L263.419 24.3981L0 110.494Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_39_944)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M290.663 110.798C278.765 123.92 268.044 138.18 257.575 151.908C248.972 163.197 240.364 174.548 231.059 185.452C222.897 195.024 213.843 204.712 203.62 212.743C173.173 236.662 139.393 248.541 100.715 244.914C79.1131 242.884 59.4372 235.232 45.5462 221.509C13.9586 190.31 19.1572 135.663 54.7622 108.661C68.8503 97.9746 79.9068 95.4952 92.5444 91.425C103.607 87.864 99.6415 79.1547 92.6599 81.2447C91.5089 81.5881 90.4313 82.2964 89.7155 83.3906C88.8574 84.6903 89.2598 86.0218 90.0482 87.1121C88.5008 86.3027 88.1992 84.1986 88.9467 83.0611C89.8032 81.7565 91.0818 80.9222 92.4457 80.5093C100.315 78.151 105.232 88.0673 92.9511 92.1688C80.6572 96.2691 69.7553 99.5419 56.6266 109.679C22.0027 136.399 16.6956 189.953 47.0337 220.333C60.5335 233.86 79.9903 241.282 101.125 243.262C139.243 246.842 172.418 235.133 202.424 211.567C212.578 203.585 221.574 193.938 229.678 184.429C238.918 173.59 247.478 162.31 256.026 151.094C260.196 145.627 264.2 140.215 268.547 134.81C275.403 126.29 282.647 117.873 290.349 109.837L290.663 110.798Z"
          fill="#9E0505"
        />
      </g>
      <path
        d="M144.987 102.822C146.59 102.862 148.075 101.917 148.796 100.399C149.773 98.8411 149.561 96.7514 148.71 95.4077C143.177 86.6298 110.743 87.0276 78.2139 101.21C116.325 86.7815 144.285 91.1224 146.437 95.8052C147.26 97.602 146.787 98.1567 145.757 98.0277C145.094 97.9429 144.417 97.8353 143.721 98.1069C142.314 98.6489 141.576 100.035 142.054 101.199C142.466 102.199 143.78 102.794 144.987 102.822Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M260.051 159.965C246.364 181.452 238.317 207.238 246.577 229.224C255.034 251.736 278.664 266.057 307.389 263.025C325.434 261.121 343.208 251.438 351.947 236.763C356.321 229.415 359.112 220.733 357.655 212.93C356.878 208.833 355 204.768 351.927 201.734C347.994 197.852 342.231 196.261 335.975 197.687C331.572 198.693 327.515 201.603 325.664 205.271C325.243 200.318 329.306 195.204 335.262 193.843C343.172 192.031 350.541 194.028 355.507 198.931C359.073 202.45 361.291 207.155 362.184 211.91C363.811 220.573 360.841 230.108 355.977 238.278C346.475 254.244 327.134 264.9 307.475 266.975C277.003 270.189 250.197 255.542 242.195 230.837C237.448 216.175 238.97 200.324 245.089 185.14C248.601 176.441 253.717 167.761 260.051 159.965Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M258.466 161.623C247.641 182.996 242.822 204.139 249.882 225.36C257.304 245.104 277.75 259.896 302.948 257.687C321.471 256.066 340.663 240.708 337.529 224.028C336.998 221.183 335.693 218.371 333.557 216.263C330.787 213.536 326.715 212.412 322.312 213.418C319.82 213.986 317.489 215.406 315.975 217.281C316.528 214.668 318.887 212.313 321.981 211.603C327.603 210.281 332.473 211.604 335.771 214.844C338.163 217.197 339.645 220.35 340.235 223.538C343.61 241.454 323.132 258.224 303.002 260.075C276.828 262.482 254.118 247.57 247.246 226.364C240.15 204.475 245.341 182.866 258.466 161.623Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M292.232 234.395C261.793 235.867 247.463 201.394 263.006 160.955C260.275 179.475 262.363 192.251 275.865 199.536C267.785 205.536 272.712 228.32 292.232 234.395Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M220.667 235.084C220.11 241.348 214.334 259.143 204.144 264.994C215.057 262.759 226.721 256.689 226.318 232.886C229.165 234.871 230.868 238.298 231.471 242.627C241.317 229.453 235.998 228.621 230.302 220.264C226.212 214.258 226.137 208.063 231.31 199.397C222.513 206.826 221.359 227.307 220.667 235.084Z"
        fill="#9E0505"
      />
      <path
        d="M204.209 217.411C193.222 227.013 187.571 238.641 192.417 246.558C195.786 252.06 200.097 253.314 202.841 252.817C204.424 252.535 205.71 252.044 206.729 251.437C205.752 251.29 204.831 250.895 204.084 250.274C203.588 249.855 203.069 249.208 202.793 248.586C201.882 246.539 202.655 244.116 204.785 242.845C207.139 241.434 210.281 241.958 211.902 243.993C213.031 245.103 213.492 246.936 212.154 249.751C208.522 257.442 192.254 260.097 187.84 247.134C184.041 235.992 192.641 225.296 204.209 217.411Z"
        fill="#9E0505"
      />
      <path
        d="M174.189 270.752C169.225 277.711 158.583 282.083 149.943 277.997C138.583 272.636 136.096 259.761 143.342 249.448C147.054 244.163 152.808 240.019 159.391 237.753L158.939 236.47C151.851 238.913 145.607 243.162 141.654 248.87C133.989 259.962 136.76 273.708 148.912 279.446C158.388 283.927 170.796 281.297 178.567 273.173C185.368 266.063 185.067 256.27 176.848 251.91C168.328 247.391 158.377 252.594 157.652 261.97C161.374 256.875 167.99 256.433 172.22 258.858C175.95 260.998 177.978 265.442 174.189 270.752Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.647 258.943C116.229 263.58 118.252 269.45 123.393 271.441C127.13 272.883 132.141 270.352 131.111 267.62C140.337 268.572 134.538 279.947 122.171 278.416C112.217 277.182 108.691 266.614 113.717 258.138C117.466 251.806 125.72 247.481 134.118 246.681C126.177 249.381 121.808 252.896 118.647 258.943Z"
        fill="#9E0505"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M213.654 127.173C211.166 125.006 211.128 120.865 213.836 118.237C215.806 116.333 219.421 116.499 219.385 118.451C224.815 115.339 218.797 109.985 211.578 114.312C205.759 117.797 205.907 125.218 210.815 129.022C214.48 131.862 220.468 132.239 225.778 130.422C220.335 130.951 216.902 130.002 213.654 127.173Z"
        fill="#9E0505"
      />
      <path
        d="M65.1579 290.585C63.8918 291.558 62.1355 291.671 60.657 290.872C58.9446 290.199 57.8856 288.381 57.7792 286.794C57.0599 276.442 83.4693 257.613 118.094 249.842C78.8124 260.708 58.8188 280.722 59.8476 285.772C60.2388 287.71 60.9542 287.877 61.7037 287.166C62.1883 286.706 62.6783 286.223 63.3993 286.025C64.8504 285.639 66.2691 286.315 66.5704 287.537C66.8284 288.587 66.1139 289.845 65.1579 290.585Z"
        fill="#9E0505"
      />
      <path
        d="M60.287 270.856C58.905 271.494 57.3462 271.231 56.3199 270.454C55.2528 269.652 54.9146 268.097 55.1963 266.876C57.0435 258.93 80.2032 249.223 106.715 249.292C76.173 250.771 57.5355 262.177 57.4156 266.156C57.3995 266.808 57.3722 267.485 58.23 266.986C58.7793 266.664 59.334 266.318 60.0191 266.291C61.3893 266.238 62.4415 267.154 62.3604 268.348C62.2941 269.367 61.3212 270.375 60.287 270.856Z"
        fill="#9E0505"
      />
    </svg>
  </section>
</template>

<style lang="scss" scoped>
.divider-flower {
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: flex-end;
  max-width: 100%;
  svg {
    margin-top: -13rem;
    height: auto;
    width: 18rem;
  }
}

/* ============================= */
/* RESPONSIVE MOBILE             */
/* ============================= */
@media (max-width: 768px) {
  .divider-flower {
    background-color: red;
    display: none;
  }
}
</style>
